/*****************************************************************************
 * Service: FundRaiser */
/**
 * @ngdoc     service
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.service:FundRaiser
 * @description
 * Handles communication with server.
 *****************************************************************************/
/* @ngInject */ export function FundraiserService(CSMHttp) {
  var mBase = 'fundraisers/';
  var get = function (route, params, data) {
    return CSMHttp.routing.get(mBase + route, params, data).then(resolve);
  };
  var post = function (route, params, data) {
    return CSMHttp.routing.post(mBase + route, params, data).then(resolve);
  };

  function resolve(resp) {
    return resp.data;
  }

  return {
    deleteFundItem: function (id) {
      return get('deleteFundItem/' + id);
    },
    drop: function (id) {
      return get('drop/' + id);
    },
    get: function (id) {
      return get('get/' + id);
    },
    getFundraisers: function () {
      return get('getFundraisers');
    },
    getClassDetail: function (id) {
      return get('getClassDetail/' + id);
    },
    getItemList: function (id) {
      return get('getItemList/' + id);
    },
    save: function (fundraiser) {
      return post('save', null, fundraiser);
    },
    saveFundraiserItem: function (item) {
      return post('saveFundraiserItem', null, item);
    }
  };
}
